import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

import { ChildBac } from '../../../models/bac.model';
import { LibraryBacHelperService } from '../../../services/library-bac-helper.service';

@Component({
  selector: 'rk-library-sbac-item',
  templateUrl: './library-sbac-item.component.html',
  styleUrls: ['./library-sbac-item.component.scss'],
})
export class LibrarySbacItemComponent implements OnInit {
  @Input()
  bac: ChildBac;

  @HostBinding('class.active')
  public isActive = false;

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly uiHelper: LibraryBacHelperService,
  ) {}

  ngOnInit() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.checkForClasses(event.urlAfterRedirects);
      }
    });
    this.route.url.subscribe(() => {
      this.checkForClasses(this.router.url);
    });
  }

  clickMenu(event: Event): void {
    event.stopPropagation();
    event.preventDefault();
  }

  checkForClasses(url: string): void {
    this.isActive = this.uiHelper.isBacActive(url, this.bac);
  }
}
